// extracted by mini-css-extract-plugin
module.exports = {"ProseMirror":"TelephonyFrame_ProseMirror__2fKBs","container":"TelephonyFrame_container__2Qlqt","container_frame":"TelephonyFrame_container_frame__9o0J9"};